import { cn } from "@/lib/utils";
import { KIT } from "@/constants/testIds";

const base =
  "ps-tap inline-flex items-center justify-center gap-2 rounded-full font-body font-semibold disabled:pointer-events-none disabled:opacity-45";

const variants = {
  // Brand rule: buttons are deep green with white text. Coral is never a button fill.
  primary: "bg-brand-teal text-white shadow-card hover:bg-brand-tealDeep hover:shadow-cardHover",
  teal: "bg-brand-teal text-white shadow-card hover:bg-brand-tealDeep hover:shadow-cardHover",
  outline: "border border-brand-teal/35 bg-white text-brand-teal hover:border-brand-teal hover:bg-secondary",
  ghost: "text-brand-teal hover:bg-secondary",
};

const sizes = {
  lg: "h-14 w-full px-8 text-[15px]",
  md: "h-11 px-6 text-sm",
  sm: "h-9 px-4 text-xs",
};

export const BrandButton = ({
  name,
  variant = "primary",
  size = "md",
  className,
  as: Tag = "button",
  children,
  ...rest
}) => (
  <Tag
    data-testid={name ? KIT.button(name) : undefined}
    className={cn(base, variants[variant], sizes[size], className)}
    {...rest}
  >
    {children}
  </Tag>
);
